import dayjs from 'dayjs'

export const getRangeLabel = (dates: Date[]) => {
  const from = dayjs(dates[0]).format('MMM D, YYYY')
  const to = dayjs(dates[1]).format('MMM D, YYYY')

  if (to === from) {
    return to
  }

  return `${from} - ${to}`
}
